import { render, staticRenderFns } from "./AssessmentMailSummaryPanel.vue?vue&type=template&id=1d5ebcac&scoped=true&"
import script from "./AssessmentMailSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./AssessmentMailSummaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentMailSummaryPanel.vue?vue&type=style&index=0&id=1d5ebcac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5ebcac",
  null
  
)

export default component.exports